








































































import { mapGetters } from 'vuex';

import {
  getInactivityTimeoutsConfiguration,
  updateInactivityTimeoutsConfiguration
} from '@/api/CopyStake/Settings';
import {
  ValidationRule,
  TCopyStakeSettingsInactiveTimeoutResponse,
  TCopyStakeSettingsInactiveTimeoutPayload
} from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import * as vr from '@/helpers/validation';
import { cloneDeep, isEqual } from 'lodash';
import type { AxiosError } from 'axios';

export default {
  name: 'CopyStakeSettingsInactivityTimeout',
  data(): any {
    return {
      inactiveTimeoutsSavedData: {
        streamer: '',
        webStreamer: '',
        webAiStreamer: ''
      },
      inactiveTimeouts: {
        streamer: '',
        webStreamer: '',
        webAiStreamer: ''
      },

      isLoading: false,
      formValid: false
    };
  },
  props: {
    title: {
      type: String,
      default: (): string => ''
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },

    inactivityTimeoutsChanged(): boolean {
      return !isEqual(this.inactiveTimeouts, this.inactiveTimeoutsSavedData);
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.inactivityTimeoutsChanged;
    },

    inactivityTimeoutRules(): ValidationRule[] {
      return [
        (v) => v === '' || v === null || vr.positiveNumber(v),
        (v) => v === '' || v === null || vr.validNumber(v),
        (v) => v === '' || v === null || vr.integer(v)
      ];
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    parseSettingsData(data: TCopyStakeSettingsInactiveTimeoutResponse): void {
      const parsedData = {
        streamer: String(data.streamer ?? ''),
        webStreamer: String(data.webStreamer ?? ''),
        webAiStreamer: String(data.webAiStreamer ?? '')
      };

      this.inactiveTimeoutsSavedData = cloneDeep(parsedData);
      this.inactiveTimeouts = cloneDeep(parsedData);
    },

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getInactivityTimeoutsConfiguration()
        .then((data: TCopyStakeSettingsInactiveTimeoutResponse) => {
          this.parseSettingsData(data);
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateConfiguration(): Promise<void> {
      const isFormValid = await this.$refs.form.validate();
      if (!isFormValid) return;

      this.isLoading = true;

      const payload: TCopyStakeSettingsInactiveTimeoutPayload =
        this.inactiveTimeouts;

      await updateInactivityTimeoutsConfiguration(payload)
        .then((data: TCopyStakeSettingsInactiveTimeoutResponse) => {
          this.parseSettingsData(data);

          this.$toast.success('Inactivity Timeout was successfully updated!');
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
